import { SUCCESS } from "../../../../../constants/action-postfix";
import { STUDENTS_INFO_REQUEST } from "../../studentsInfoReducer";


const initialState = null;

export const summaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${STUDENTS_INFO_REQUEST}${SUCCESS}`:
            return action.payload.summary;
        default:
            return state;
    }
};
